import { render, staticRenderFns } from "./assign-follow-up.vue?vue&type=template&id=7ad9c43a"
import script from "./assign-follow-up.vue?vue&type=script&lang=js"
export * from "./assign-follow-up.vue?vue&type=script&lang=js"
import style0 from "./assign-follow-up.vue?vue&type=style&index=0&id=7ad9c43a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports